import { observer } from 'owa-mobx-react';
import React from 'react';
import ShimmerRowThreeCol from './ShimmerRowThreeCol';
import ShimmerRowSLV from './ShimmerRowSLV';
import { getMinimumRowHeight, isSingleLineListView } from 'owa-mail-layout';
import { getMailListLoadDatapoint } from 'owa-mail-logging/lib/utils/mailListLoad/mailListLoadDatapointGetterAndSetter';
import { getDensityModeString } from 'owa-fabric-theme';

import classNames from 'owa-classnames';
import { hideScrollContainers, mailListShimmerStateContainer } from './MailListShimmerState.scss';

export interface MailListShimmerStateProps {
    heightOfView: number; // The height of the list view
}

const MailListShimmerState: React.FunctionComponent<MailListShimmerStateProps> = observer(
    function MailListShimmerState(props: MailListShimmerStateProps) {
        const shimmerRows = [];
        const isSingleLineViewOff = !isSingleLineListView();
        const densityModeString = getDensityModeString();

        // Calculate height of shimmer rows to add just enough rows to fill list view
        let totalHeightOfView = 0;
        const shimmerRowHeight = getMinimumRowHeight(false /* isCondensedRow */);
        const hasMounted = React.useRef<boolean>(false);

        React.useEffect(() => {
            // Only on the first mount of the component, append the checkpoint to MLL that marks the loading of the Shimmer component.
            if (!hasMounted.current) {
                hasMounted.current = true;
                const mllDp = getMailListLoadDatapoint();
                if (mllDp) {
                    mllDp.addToCustomWaterfall(
                        1,
                        'lc_rendered', // loading component rendered
                        true /*discardIfDefined*/
                    );
                    mllDp.addCustomData({ lc: 'Shimmer' }); // loading component
                }
            }
        }, []);

        // Account for padding on the first message
        // Should correspond with the paddingFirstMessage/paddingMessage classes in
        // ShimmerRowSLV.scss and ShimmerRowThreeCol.scss
        if (isSingleLineViewOff) {
            densityModeString === 'full' ? (totalHeightOfView += 6) : (totalHeightOfView += 10);
        } else {
            densityModeString === 'full' ? (totalHeightOfView += 4) : (totalHeightOfView += 6);
        }

        let i = 0;
        while (totalHeightOfView < props.heightOfView) {
            shimmerRows.push(
                isSingleLineViewOff ? (
                    <ShimmerRowThreeCol key={i} isFirstMessage={i === 0} />
                ) : (
                    <ShimmerRowSLV key={i} isFirstMessage={i === 0} />
                )
            );
            ++i;
            totalHeightOfView += shimmerRowHeight;
        }

        return (
            <div className={classNames(hideScrollContainers, mailListShimmerStateContainer)}>
                {shimmerRows}
            </div>
        );
    },
    'MailListShimmerState'
);
export default MailListShimmerState;
